module.exports = "https://www.gc-qa.gnp.com.mx/c24dfd5a36f296b4dd364737d9cca517.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dbk_reg_km_init.png
// module id = 1816
// module chunks = 0